<div class="alerts">
  <page-alert [message]="messageSuccess" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
  <page-alert [message]="messageError" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>
</div>

<div class="row">
  <div class="col-xs-8 col-md-10">
    <page-title [title]="titleSpecialties" class="horario subtitle"></page-title>
  </div>
  <div class="col-xs-4 col-md-2 btAdd">
    <button mat-stroked-button color="primary" (click)="addSpecialties()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>

<div *ngFor="let specialty of specialties; let i = index; trackBy: trackByIndex">
  <div class="row speciality">
    <div class="col-xs-12 col-sm-6  col-md-5">


      <mat-form-field class="example-full-width" appearance="outline">
        <input matInput name="specName{{ i }}" [(ngModel)]="specialty.value" required minlength="3" placeholder="Nome"
          [matAutocomplete]="auto" (click)="getTussBYPrefix(specialty.value)"
          (keydown)="allowLettersKeydown($event);getTussBYPrefix(specialty.value)" (paste)="onPasteLetters($event)" />
        <mat-label>Especialidade</mat-label>

        <mat-error *ngIf="!specialty.value">Obrigatório.</mat-error>
        <mat-error *ngIf="specialty.value && specialty.value.length < 3">Mín. 3 caracteres.</mat-error>
      </mat-form-field>


      <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption>
        <mat-option *ngFor="let item of specialtyTuss" [value]="item.termo">
          <div class="option-item">
            <span class="option-name">{{ item.termo }}</span>
          </div>
        </mat-option>
        <mat-option *ngIf="specialtyTuss.length === 0 && loading" disabled>
          <div class="option-item">
            <span class="option-name text-gray-500">Procedimento não encontrado</span>
          </div>
        </mat-option>
      </mat-autocomplete>

    </div>

    <div class="col-xs-12 col-sm-6 col-md-4">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Registro Profissional</mat-label>
        <input matInput name="crm{{ i }}" [(ngModel)]="specialty.crm" required maxlength="6" minlength="5"
          inputmode="numeric" pattern="^\d{5,6}$" placeholder="CRM" (keydown)="allowNumbersKeydown($event)"
          (paste)="onPasteNumbers($event)" />
        <mat-error *ngIf="!specialty.crm">Obrigatório.</mat-error>
        <mat-error *ngIf="specialty.crm && specialty.crm.length < 5">Mín. 5 dígitos.</mat-error>
      </mat-form-field>
    </div>

    <div class="col-xs-12 col-sm-5 col-md-2">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>UF</mat-label>
        <mat-select name="uf{{ i }}" [(ngModel)]="specialty.uf" required placeholder="Selecione a UF">
          <mat-option *ngFor="let uf of ufs" [value]="uf">{{ uf }}</mat-option>
        </mat-select>
        <mat-error *ngIf="!specialty.uf">Selecione uma UF.</mat-error>
      </mat-form-field>
    </div>

    <div class="col-xs-12 col-sm-1 col-md-1" style="margin-top: 12px;">
      <button mat-icon-button color="warn" class="btRm" aria-label="Remover especialidade" (click)="removeSpecialty(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>

</div>

<div class="row">
  <div class="col-xs-12 actions">
    <button *ngIf="mode === 'UPDATE'" mat-flat-button color="primary" (click)="save()"
      [disabled]="isSaving || !isFormValid()">
      <ng-container *ngIf="!isSaving">Salvar alterações</ng-container>
      <ng-container *ngIf="isSaving"><mat-progress-spinner mode="indeterminate" diameter="20"
          strokeWidth="3"></mat-progress-spinner></ng-container>
    </button>

    <button *ngIf="mode === 'CREATE'" mat-flat-button color="primary" (click)="create()"
      [disabled]="isSaving || !isFormValid()">
      <ng-container *ngIf="!isSaving">Criar Especialidade</ng-container>
      <ng-container *ngIf="isSaving"><mat-progress-spinner mode="indeterminate" diameter="20"
          strokeWidth="3"></mat-progress-spinner></ng-container>
    </button>
  </div>
</div>